import dayjs, { Dayjs } from 'dayjs';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import { FC } from 'react';

interface DeployDateTimePickerProps extends DateTimePickerProps<Dayjs> {
    customOnChange: (newValue: Dayjs) => void;
}

const MIN_HOURS_AHEAD = 2;
const MAX_DAYS_AHEAD = 30;

const DeployDateTimePicker: FC<DeployDateTimePickerProps> = ({
    customOnChange,
    disablePast = true,
    ampm = false,
    ...props
}) => {
    const currentDate = dayjs();
    const minDate = currentDate.add(MIN_HOURS_AHEAD, 'hour').startOf('hour');
    const maxDate = currentDate.add(MAX_DAYS_AHEAD, 'day').startOf('hour');

    const onDateTimeChange = (newValue: Dayjs | null) => {
        if (!newValue) return;

        let hardModifiedValue: Dayjs | null = null;
        const isToday = newValue.isSame(currentDate, 'day');

        if (newValue > maxDate) {
            hardModifiedValue = maxDate;
        }

        // if is today and time value is less than hour to current time, set minimal available time
        if (isToday && newValue.isBefore(minDate)) {
            hardModifiedValue = minDate;
        }

        customOnChange(hardModifiedValue || newValue);
    };

    const shouldDisableTime = (value: Dayjs) => value.isAfter(maxDate) || value.isBefore(minDate);

    return (
        <DateTimePicker
            views={['month', 'day', 'hours']}
            minutesStep={60}
            timeSteps={{ hours: 1, minutes: 60 }}
            shouldDisableTime={shouldDisableTime}
            disablePast={disablePast}
            ampm={ampm}
            {...props}
            minDate={minDate}
            maxDate={maxDate}
            onChange={onDateTimeChange}
        />
    );
};

export default DeployDateTimePicker;
